// opt in to HRM with Parcel JS
if (module.hot) {
  module.hot.accept();
}

// import the sassy styles ***********************
import "./site.scss";


// plugin scripts *****************************
require('./js/total-modal.js');


// custom scripts *****************************
// NOTE: enable script below if you have a DROP DOWN MAIN MENU -> then update classes in script for your site
// require('./js/touch-navigation');
require('./js/scripts');
